import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";

/**
 * Use Case: Run PASCO Pipeline
 * Triggers the PASCO processing pipeline
 */
export class RunPascoPipelineUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @returns Promise<void>
     */
    async execute(): Promise<void> {
        await this.pascoRepository.runPipeline();
    }
}
